import React from "react";
import { some } from "lodash";

import News from "~/blocks/News";

import useStringTranslation from "~/hooks/translations/useStringTranslation";
import useAllNewsArticles from "~/hooks/data/useAllNewsArticles";

const NewsArticleNews = ({ data }) => {
    const {
        wpNewsArticle: { id, translations },
    } = data;

    const { moreArticlesText } = useStringTranslation([
        { text: "More Articles", handle: "moreArticlesText" },
    ]);

    const { formattedArticles } = useAllNewsArticles({
        limit: 4,
        initialFilter: (article) => {
            const isTranslation = some(translations, { id: article.id });
            return article.id !== id && !isTranslation;
        },
    });

    return (
        <News withBorder title={moreArticlesText} cards={formattedArticles} />
    );
};

export default NewsArticleNews;
